import React from "react";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";

// Custom components
import colors from "../../constants/Colors";
import { LoadingButton, StyledTextField } from "../general";
import validator from "validator";

const DetailsForm = ({
  goBack,
  trySignUp,
  signUpLoading,
  editErrors,
  formErrors,
  editFormData,
  formData,
  t,
}) => {
  const requiredFields = [
    {
      name: "firstName",
      error: t("auth.noFirstNameError"),
      label: t("auth.firstName"),
    },
    {
      name: "lastName",
      error: t("auth.noLastNameError"),
      label: t("auth.lastName"),
    },
  ];

  const validateForm = () => {
    let passed = true;
    let errors = {};

    requiredFields.forEach((requiredField) => {
      if (!formData[requiredField.name]) {
        passed = false;
        errors[requiredField.name] = requiredField.error;
      } else if (validator.isEmpty(formData[requiredField.name])) {
        passed = false;
        errors[requiredField.name] = requiredField.error;
      } else {
        errors[requiredField.name] = "";
      }
    });

    editErrors(errors);
    return passed;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let passed = validateForm();
    if (passed === true) {
      trySignUp();
    }
  };

  return (
    <Grid container alignItems="center" style={{ height: "100%" }}>
      <Grid item style={{ flex: 1 }}>
        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
          <div style={{ padding: 10 }}>
            {requiredFields.map((requiredField) => (
              <StyledTextField
                key={requiredField.name}
                name={requiredField.name}
                onChange={(e) => {
                  editFormData(requiredField.name, e.target.value);
                }}
                value={formData[requiredField.name]}
                label={requiredField.label}
                error={
                  formErrors[requiredField.name] &&
                  formErrors[requiredField.name] !== ""
                }
                errorText={formErrors[requiredField.name]}
              />
            ))}
            <LoadingButton
              text={t("auth.registerAccount")}
              loading={signUpLoading}
            />
            <Grid item>
              <p
                onClick={goBack}
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  cursor: "pointer",
                  color: colors.grey,
                }}
              >
                {t("general.goBack")}
              </p>
            </Grid>
          </div>
        </form>
      </Grid>
    </Grid>
  );
};

export default withTranslation("common")(DetailsForm);
